{
  "version": 1,
  "asset_id": "333177c6-1373-4c88-bc8b-3a65cf3119be",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/333177c6-1373-4c88-bc8b-3a65cf3119be/towing-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/333177c6-1373-4c88-bc8b-3a65cf3119be/towing-thumb.webp",
  "original_filename": "towing-thumb.webp",
  "size": 3980,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:42Z"
}
